import {
  AllFacets,
  Creative,
  ICreativeIndexResponse,
  ICreativeRequest,
  IFindCreativesResponse,
} from '@kaizenplatform/creative-search-entity';
import { AxiosInstance } from 'axios';

import CreativeIndexForDirectorWeb from '../../entity/CreativeForDirectorWeb';

class AdSearchWebApi {
  private httpClient: AxiosInstance;

  constructor({ httpClient }: { httpClient: AxiosInstance }) {
    this.httpClient = httpClient;
  }

  /**
   * creative一覧を取得する。
   * @param request request. APIはcreative search と共有しており、受入可能なプロパティはもっと広いため、差分がある.
   */
  public getCreatives = async (request: ICreativeRequest): Promise<CreativeIndexForDirectorWeb> => {
    const response = await this.httpClient.get('/creatives', {
      params: { ...request, contentType: 'video/mp4,video/quicktime,video/mpeg' },
    });
    const body: ICreativeIndexResponse = await response.data;
    const entity = {
      count: body.count,
      // FIXME: I/Fの型がどうしてもあわないのでany. entityの中で型のチェックやバリデーションを行うので戻り値は信頼できると言う前提にたっている.
      creatives: body.creatives.map((creative) => Creative.fromJSON(creative as any)),
      facets: AllFacets.fromJSON(body.allFacets),
    };
    return entity;
  };

  /**
   * 指定IDのcreativeを取得する
   */
  public getCreativesByIds = async (cardIds: string[]): Promise<Creative[]> => {
    const response = await this.httpClient.get(`/creatives/find`, {
      params: {
        ids: cardIds.join(','),
      },
    });
    const body: IFindCreativesResponse = await response.data;
    // FIXME: I/Fの型がどうしてもあわないのでany. entityの中で型のチェックやバリデーションを行うので戻り値は信頼できると言う前提にたっている.
    const entity = body.creatives.map((creative) => Creative.fromJSON(creative as any));
    return entity;
  };

  /**
   * 組織に紐づくtagの追加をする
   *
   * @description oraganization_tagはログインユーザーに紐づく組織からしか見えない領域のタグ. 他社事例検索時に情報漏洩を防ぐ目的でtagと別に使われている。
   * @params cid Creative ID
   * @params name tagの名前
   * @params oid 組織id
   */
  public addTagToCreative = async (cid: string, name: string, oid: number) => {
    await this.httpClient.post(`/creatives/${cid}/organization_tags`, {
      name,
      organizationId: oid,
      id: cid,
    });
  };

  /**
   * 組織に紐づくtagの削除をする
   *
   * @description oraganization_tagはログインユーザーに紐づく組織からしか見えない領域のタグ. 他社事例検索時に情報漏洩を防ぐ目的でtagと別に使われている。
   * @params cid Creative ID
   * @params name tagの名前
   * @params oid 組織id
   */
  public deleteTagfromCreative = async (cid: string, name: string, oid: number) => {
    await this.httpClient.delete(`/creatives/${cid}/organization_tags`, {
      data: { name, organizationId: oid },
    });
  };

  /**
   * creativeに対してFavをする
   */
  public creativeFav = async (cid: string) => {
    await this.httpClient.post(`/creatives/${cid}/favorites`);
  };

  /**
   * creativeのFavを解除する
   */
  public creativeUnfav = async (cid: string) => {
    await this.httpClient.delete(`/creatives/${cid}/favorites`);
  };
}

export default AdSearchWebApi;
